import { render } from "./pravacy.vue?vue&type=template&id=0cf922b8&scoped=true"
import script from "./pravacy.vue?vue&type=script&lang=js"
export * from "./pravacy.vue?vue&type=script&lang=js"

import "./pravacy.vue?vue&type=style&index=0&id=0cf922b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cf922b8"]])

export default __exports__